import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, FormikValues } from 'formik';
import { Col, Form, Row } from 'react-bootstrap';

import * as routes from '@routes';
import { useAuthApi } from '@api/auth';
import { usePageStore } from '@stores';
import { Button } from '@components';

const ResetPasswordForm: React.FC = () => {
  const authApi = useAuthApi();
  const pageState = usePageStore();

  const handleFormSubmit = (
    values: FormikValues,
    setSubmitting: (isSubmitting: boolean) => void,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    authApi
      .resetPassword(values.email)
      .then(() => {
        setFieldValue('email', '');
        setSubmitting(false);
      })
      .catch((err) => {
        if (authApi.isCancel(err)) {
          return;
        }
        setSubmitting(false);
      });
  };

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      onSubmit={(values, { setSubmitting, setFieldValue }) => {
        handleFormSubmit(values, setSubmitting, setFieldValue);
      }}
    >
      {(formProps) => (
        <Form onSubmit={(e: React.FormEvent<HTMLFormElement>) => formProps.handleSubmit(e)}>
          <Form.Group>
            <Form.Label>E-mail</Form.Label>
            <Form.Control
              required={true}
              disabled={formProps.isSubmitting}
              type="email"
              value={formProps.values.email}
              name="email"
              onChange={formProps.handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-0">
            <Row className="align-items-center mt-4 pt-2">
              <Col xs={6}>
                <Button disabled={formProps.isSubmitting} variant="btn-outline-primary" type="submit">
                  Resetovat
                </Button>
              </Col>
              <Col xs={6} className="text-right">
                <Link to={pageState.getPagePath(routes.auth.LOGIN)}>Přihlásit se</Link>
              </Col>
            </Row>
          </Form.Group>
        </Form>
      )}
    </Formik>
  );
};

export default ResetPasswordForm;
